import { memo } from 'react';
import { useStepper } from './hooks/use-stepper';
import { StepperProps } from './stepper.types';
import { SVG } from '../svg';
import { Icons } from '../icons';
import { Container, StepperButton } from './stepper.styled';

export const Stepper = memo((props: StepperProps) => {
  const {
    value,
    onChange,
    onBlur,
    step = 1,
    min = Number.MIN_SAFE_INTEGER,
    max = Number.MAX_SAFE_INTEGER,
    allowDecimals = false,
    precision = 2,
    disabled,
    style,
    ...rest
  } = props;

  const {
    inputValue,
    currentValue,
    handleInputChange,
    handleBlur,
    handleStep,
    handleKeyDown,
  } = useStepper({
    value,
    onChange,
    onBlur,
    step,
    min,
    max,
    allowDecimals,
    precision,
    disabled,
  });

  return (
    <Container style={style}>
      <StepperButton
        type="button"
        onClick={() => handleStep('down')}
        disabled={currentValue <= min || disabled}
        aria-label="Уменьшить"
      >
        <SVG src={Icons.Minus} />
      </StepperButton>

      <input
        {...rest}
        value={inputValue}
        type="text"
        inputMode="decimal"
        step="any"
        onChange={handleInputChange}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        disabled={disabled}
        min={min}
        max={max}
      />

      <StepperButton
        type="button"
        onClick={() => handleStep('up')}
        disabled={currentValue >= max || disabled}
        aria-label="Увеличить"
      >
        <SVG src={Icons.Plus} />
      </StepperButton>
    </Container>
  );
});
